import { styled } from '@linaria/react';

export const ProgressBar = styled.div<{
	progress: number;
	height: number;
	width?: number;
}>`
	overflow: hidden;
	width: ${({ width }) => (width ? width + 'rem' : 'unset')};
	height: ${({ height }) => height + 'rem'};
	border-radius: var(--radius-xs);
	background-color: var(--color-white-m);

	&::after {
		display: block;
		width: ${({ progress }) => progress + '%'};
		height: 100%;
		border-radius: var(--radius-xs);
		background-color: var(--color-white-solid);
		content: '';
		transition: width 0.1s linear;
	}
`;
